// Derives the shared auth root domain from a hostname by stripping the first
// label, so cookieStorage and hub redirects work consistently across
// environments (dagbok.ibit.no → ibit.no, dagbok.arcfoundry.localtest.me →
// arcfoundry.localtest.me). Hostnames with fewer than three labels (apex
// domains, `localhost`, IPs) are returned as-is; cookieStorage falls back to
// localStorage in those cases.
export function resolveAuthDomain(hostname: string): string {
  const labels = hostname.split(".");
  if (labels.length < 3) return hostname;
  return labels.slice(1).join(".");
}
